@let sequence = sequence$ | async;
<div class="layout-col full">
  <!-- Header Section -->
  @if (sequence) {
    <div class="layout-row">
      @if (!embedded) {
        <mat-toolbar elderTheme class="gap-md">
          <button mat-icon-button (click)="onClose($event)">
            <mat-icon>close</mat-icon>
          </button>
          <ng-container
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: sequence }"
          ></ng-container>
        </mat-toolbar>
      }
    </div>
  }

  <!-- Content -->
  <div class="flex layout-col">
    <mat-tab-group class="flex" animationDuration="0ms">
      <!-- Tab Overview -->
      <mat-tab label="{{ 'context.overview' | translate }}">
        <elder-single-pane-wrapper>
          <elder-pane-header>
            <elder-pane-title>{{ 'context.general' | translate }}</elder-pane-title>

            <elder-pane-actions>
              @if (canSave && sequence) {
                <button mat-icon-button (click)="onSave($event)">
                  <mat-icon>save</mat-icon>
                </button>
              }

              <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>

              <mat-menu #menu="matMenu">
                <button
                  mat-menu-item
                  (click)="onDelete($event)"
                  [disabled]="!canDelete || !sequence"
                >
                  <mat-icon>delete</mat-icon>
                  <span>{{ 'actions.delete' | translate }}</span>
                </button>
              </mat-menu>
            </elder-pane-actions>
          </elder-pane-header>

          <elder-pane-content>
            @if (sequence) {
              <form #mainFrm="ngForm" class="flex layout-col">
                <div class="layout-row gap-xl">
                  <!-- Identification -->
                  <div class="flex layout-col">
                    <h4 elderpaneSubtitle>{{ 'context.identification' | translate }}</h4>
                    <div class="layout-row gap-md">
                      <mat-form-field class="flex">
                        <mat-label>{{ 'ID' | translate }}</mat-label>
                        <input
                          matInput
                          name="id"
                          readonly
                          placeholder="{{ 'ID' | translate }}"
                          pattern="{{ idValidatorPattern }}"
                          [(ngModel)]="sequence.id"
                          #idModel="ngModel"
                        />
                        <mat-error elderValidationError></mat-error>
                      </mat-form-field>
                      <mat-form-field class="flex">
                        <mat-label>{{ 'context.template' | translate }}</mat-label>
                        <input
                          matInput
                          name="template"
                          required
                          placeholder="{{ 'context.template' | translate }}"
                          [(ngModel)]="sequence.template"
                          #nameModel="ngModel"
                        />
                        <mat-error elderValidationError></mat-error>
                      </mat-form-field>
                      <mat-form-field class="flex">
                        <mat-label>{{ 'numberSequences.scope' | translate }}</mat-label>
                        <input
                          matInput
                          name="scope"
                          readonly
                          placeholder="{{ 'numberSequences.scope' | translate }}"
                          [(ngModel)]="sequence.primaryCounterSpec.scope"
                          #nameModel="ngModel"
                        />
                        <mat-error elderValidationError></mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="flex layout-row gap-xl">
                  <div class="flex layout-col gap-lg">
                    <!-- Counter Format -->
                    <h4 elderpaneSubtitle>{{ 'numberSequences.format' | translate }}</h4>
                    <div class="layout-row gap-md">
                      <mat-form-field class="flex">
                        <mat-label>{{ 'minVal' | translate }}</mat-label>
                        <input
                          matInput
                          name="minVal"
                          type="number"
                          placeholder="{{ 'minVal' | translate }}"
                          [(ngModel)]="sequence.primaryCounterSpec.minValue"
                          #minModel="ngModel"
                        />
                        <mat-error elderValidationError></mat-error>
                      </mat-form-field>
                      <mat-form-field class="flex">
                        <mat-label>{{ 'maxVal' | translate }}</mat-label>
                        <input
                          matInput
                          name="maxVal"
                          type="number"
                          placeholder="{{ 'maxVal' | translate }}"
                          [(ngModel)]="sequence.primaryCounterSpec.maxValue"
                          #maxModel="ngModel"
                        />
                        <mat-error elderValidationError></mat-error>
                      </mat-form-field>
                    </div>
                    <app-variable-format-detail
                      [format]="sequence.primaryCounterSpec.variableSpec.format"
                    >
                    </app-variable-format-detail>
                    <!-- Variable Formats -->
                    <h4 elderpaneSubtitle>{{ 'numberSequences.variableFormats' | translate }}</h4>
                    @for (varSpec of sequence.variableSpecs | keyvalue; track varSpec) {
                      <div class="layout-col gap-sm">
                        <span>{{ varSpec.key }}</span>
                        <app-variable-format-detail [format]="varSpec.value.format">
                        </app-variable-format-detail>
                      </div>
                    }
                  </div>
                  <div class="flex layout-col"></div>
                </div>
              </form>
            } @else {
              @if (canCreate && !sequence) {
                <button mat-icon-button (click)="onCreate($event)">
                  <mat-icon>add</mat-icon>
                </button>
              }
            }
          </elder-pane-content>
        </elder-single-pane-wrapper>
      </mat-tab>

      <mat-tab class="full" label="{{ 'numberSequences.currentCounters' | translate }}">
        <elder-single-pane-wrapper>
          <p>Wird demnächst implementiert</p>
        </elder-single-pane-wrapper>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>

<ng-template #header let-sequence>
  <div class="layout-row place-start-center gap-xl">
    <elder-header [header]="sequence.id"></elder-header>
  </div>
</ng-template>
